import React, { useReducer, useState } from "react";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../elements/FormStyle/FormStyle.css';
import './LogIn.css';

const formInputReducer = (state, input) => {
    if (input.type === 'reset') {
        return {
            email: '',
            password: ''
        }
    }
    return {
        ...state,
        [input.name]: input.value
    }
}

const LogIn = () => {
    const [formInputs, setFormInputs] = useReducer( formInputReducer, {
        email: '',
        password: ''
    });
    const [submit, setSubmit] = useState(false);
    const [info, setInfo] = useState('');
    const [passToggle, setPassToggle] = useReducer(state => !state, false);

    

    const handleLogIn = (e) => {
        e.preventDefault();
        setSubmit(true);
        axios.post('https://lerntutors.com/react_2026_api/login.php', formInputs)
        .then(res => res.data)
        .then(data => {
            if (data.status === 'success') {
                setFormInputs({
                    type: 'reset'
                });

                if (data.user === 'admin') {
                    localStorage.setItem('user', 'admin');
                    window.location.href = `/adminportal/${data.aduser}`;
                }
                else if (data.user === 'student') {
                    localStorage.setItem('user', 'student');
                    localStorage.setItem('sid', data.sid);
                    window.location.href = `/studentportal/${data.sid}`;
                }
            }
            else if (data.status === 'failure') {
                setInfo(data.message);
            }
            else {
                setInfo('Log in failed. Please check details and try again.');
            }
            setSubmit(false);
            setTimeout(() => {
                setInfo('');
            }, 2000);
        })
    }

    return (
        <div className="lern-login">
            <div className="form-div">
                <form onSubmit={handleLogIn}>
                    {info && <p className="alert alert-danger text-center">{info}</p>}
                    <fieldset>
                        <legend>Log In</legend>
                        <div className="form-group">
                            <input type="text" name="email" placeholder="Email Address" onChange={(e) => setFormInputs(e.target)} value={formInputs.email} required />
                        </div>
                        <div className="form-group my-group">
                            <input type={passToggle ? "text" : "password"} name="password" placeholder="Password" onChange={(e) => setFormInputs(e.target)} value={formInputs.password} required />
                            <span className="input-group-text btn btn-secondary" onClick={setPassToggle}>{passToggle ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}</span>
                        </div>
                        <div className="form-group btn-div">
                            <input type="submit" name="sub-btn" value="Log In" disabled={submit} />
                        </div>
                    </fieldset>
                </form>
                <div className="form-links">
                    <Link to="/recoverpassword">Recover Password</Link>
                </div>
            </div>
            <div className="enroll-link">
                <Link to="/courses">Take a Course</Link>
            </div>
        </div>
    )
}

export default LogIn;